<template>
  <span :class="{ 'text-primary': !isValid }">
    {{ strippedValue.length }}/{{ maxLength }}
    <help>Maximum characters</help>
  </span>
</template>

<script>
  import Help from './Help';

  export default {
    name: 'CharacterCount',

    components: {
      Help,
    },

    props: {
      value: String,
      maxLength: Number,
    },

    computed: {
      isValid() {
        return this.value.length <= this.maxLength;
      },
      strippedValue() {
        let newvalue = this.value.replace(/(<([^>]+)>)/gi, '');
        return newvalue;
      },
    },
  };
</script>
